import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

import type { ResearchIndexDispatch, ResearchIndexState } from './types';

export const useDispatch: () => ResearchIndexDispatch = useReduxDispatch;
export const useSelector: TypedUseSelectorHook<ResearchIndexState> = useReduxSelector;